import type { LucideIcon } from "lucide-react";
import { Link } from "wouter";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export interface ContentStudioCardProps {
  href: string;
  icon: LucideIcon;
  title: string;
  description: string;
  dataTestId?: string;
}

export function ContentStudioCard({
  href,
  icon: Icon,
  title,
  description,
  dataTestId,
}: ContentStudioCardProps) {
  return (
    <Link href={href}>
      <Card
        className="hover-elevate cursor-pointer h-full"
        data-testid={dataTestId}
      >
        <CardHeader className="flex flex-row items-center gap-3 pb-2">
          <div className="p-2 rounded-md bg-primary/10">
            <Icon className="h-5 w-5 text-primary" />
          </div>
          <CardTitle className="text-base">{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">{description}</p>
        </CardContent>
      </Card>
    </Link>
  );
}
